import React from 'react'
import { differenceInMilliseconds } from 'date-fns'

import { useEnvironment } from '../../../../providers/EnvironmentProvider'
import { useReadStatus } from '../../../../providers/ReadStatusProvider'
import { useUserAPI } from '../../../../providers/UserAPIProvider'
import useStyles from './styles'

const OFFSET_MILLIS = 500

const ReadInfo = ({ date, session, sender, isPeerChat }) => {
  const { user } = useEnvironment()
  const { convos } = useReadStatus()
  const { allUsers: users, loadUser } = useUserAPI()

  const [names, setNames] = React.useState('...')
  const [ids, setIDs] = React.useState([])
  const read = React.useMemo(() => convos[session] ?? null, [convos, session])

  const classes = useStyles()

  // Determine if all, none, or some users read this
  React.useEffect(() => {
    if (!read) {
      setNames('nobody')
      return
    }

    const asDate = new Date(date)
    const all = Object.entries(read).filter(x => x[0] !== sender)
    const filtered = all.filter(x => {
      const current = new Date(x[1])
      return differenceInMilliseconds(asDate, current) < OFFSET_MILLIS
    })
    if (filtered.length === 0) {
      setNames('nobody')
      return
    }

    const ids = filtered.map(u => u[0])
    if (isPeerChat) {
      setIDs([ids[0]])
      return
    }

    if (ids.length !== all.length) {
      setIDs(ids)
    } else {
      setNames('everybody')
    }
  }, [read, date, sender, isPeerChat])

  // Get names of users who read this message
  React.useEffect(() => {
    if (!ids.length) {
      return
    }

    const nameList = []
    let foundAll = true

    ids.forEach(id => {
      const foundUser = users[id]
      if (foundUser) {
        const name = user.id === id ? 'you' : foundUser.name
        nameList.push(name)
      } else {
        foundAll = false
        loadUser(id)
      }
    })

    if (foundAll) {
      setNames(nameList)
    }
  }, [ids, users, user, loadUser])

  return Array.isArray(names) ? (
    <div className={classes.root}>
      Read by <span className={classes.names}>{names.join(', ')}</span>
    </div>
  ) : (
    <div className={classes.root}>Read by {names}</div>
  )
}

export default ReadInfo
